import React, { useEffect, useState } from 'react';
import {Link, NavLink} from 'react-router-dom';
import logo from '../assets/images/mindraft-logo-dark.png';
import logoWhite from '../assets/images/mindraft-logo.png';

function NavMenuToggle(){
    setTimeout(()=>{
        let toggleBtn = document.getElementById('navbutton');
        let sidebarOpen = document.getElementById('navbarNavDropdown');
        toggleBtn.classList.toggle("open");
        sidebarOpen.classList.toggle("show")
    },200)
}


const Header = (props) => {
    const [headerFix, setheaderFix] = React.useState(false);
	useEffect(() => {
		window.addEventListener("scroll", () => {
			setheaderFix(window.scrollY > 50);
		});
	}, []); 
    const [openMenu,setOpenMenu] = useState(false);
    return (
        <header className={`site-header mo-left header ${props.style}`}>		
            <div className={`sticky-header main-bar-wraper navbar-expand-lg ${headerFix ? "is-fixed" : ""}`}>
                <div className="main-bar clearfix ">
                    <div className="container clearfix">
                        <div className="logo-header">                        
                            <Link to={"/"} className="logo-light"><img src={logoWhite} alt=""/></Link>
						    <Link to={"/"} className="logo-dark"><img src={logo} alt=""/></Link>  
                        </div>                        
                        <button className="navbar-toggler collapsed navicon justify-content-end" type="button" id="navbutton"
                            onClick={()=>NavMenuToggle()}
                        >
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                        
                        <div className="extra-nav">
                            <div className="extra-cell">
                                <Link to={"https://superadmin.mindrafttech.com/"} className="btn btn-outline-primary text-primary">Login to Dashboard</Link>
                                <a href="#contact-us" className="btn btn-primary  btn-shadow">Request Demo</a>
                            </div>
                        </div>

                        <div className="header-nav navbar-collapse collapse justify-content-end" id="navbarNavDropdown">
                            <div className="logo-header logo-dark">
                                <Link to={"#"}><img src={logo} alt="" /></Link>
                            </div>
                            <ul className="nav navbar-nav navbar navbar-left"> 
                                <li><NavLink to={"/"}>Home</NavLink></li>
                                <li><a href="#about-us">About Us</a></li>
                                <li><a href="#contact-us">Contact Us</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}
export default Header;
